export enum GeniallyAuditEventType {
  GeniallyConvertedToTeamTemplate = 'GeniallyConvertedToTeamTemplate',
  GeniallyCopySentBetweenTeams = 'GeniallyCopySentBetweenTeams',
  GeniallyCopyAcceptedSentBetweenTeams = 'GeniallyCopyAcceptedSentBetweenTeams',
  GeniallyReused = 'GeniallyReused',
  GeniallyBlankCreated = 'GeniallyBlankCreated',
  GeniallyCreatedFromTeamTemplate = 'GeniallyCreatedFromTeamTemplate',
  GeniallyDuplicated = 'GeniallyDuplicated',
  GeniallyFromTemplateCreated = 'GeniallyFromTemplateCreated',
  GeniallyImported = 'GeniallyImported',
  GeniallyMarkedAsDeleted = 'GeniallyMarkedAsDeleted',
  GeniallyRemovedAsTeamTemplate = 'GeniallyRemovedAsTeamTemplate',
  GeniallyRestored = 'GeniallyRestored',
  GeniallyMovedToSpaceRoot = 'GeniallyMovedToSpaceRoot',
  GeniallyMovedToFolder = 'GeniallyMovedToFolder',
  GeniallyMovedFromOtherTeam = 'GeniallyMovedFromOtherTeam',
  GeniallyMovedToOtherTeam = 'GeniallyMovedToOtherTeam',
  GeniallySentToTeam = 'GeniallySentToTeam',
  GeniallyRenamed = 'GeniallyRenamed',
  GeniallyDeleted = 'GeniallyDeleted',
  GeniallyChangesPublished = 'GeniallyChangesPublished',
}
